/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { colors, typography, measure, onMedia, GLOBAL_SHADOW } from "../styles"
import { Link } from "../components/Link"

export const PrimaryAction = ({ children, ...restProps }) => {
  //  <a> || <Link> if (href matches path regex) ???

  return (
    <Link
      css={[
        {
          display: "inline-block",
          padding: "0.5rem 1rem",
          margin: "1rem",
          color: colors.PAPER_WHITE,
          fontFamily: typography.MUSEO,
          fontWeight: 700,
          fontSize: "2rem",
          textDecoration: "none",
          textAlign: "center",
          borderRight: `solid ${colors.PAPER_WHITE} ${measure.THICK_BORDER}`,
          borderBottom: `solid ${colors.PAPER_WHITE} ${measure.THICK_BORDER}`,
          backgroundColor: colors.BLUE,
          boxShadow: GLOBAL_SHADOW,
        },
        onMedia("hover: hover", {
          "&:hover": {
            color: colors.BLUE,
            borderRight: `solid ${colors.BLUE} ${measure.THICK_BORDER}`,
            borderBottom: `solid ${colors.BLUE} ${measure.THICK_BORDER}`,
            backgroundColor: colors.PAPER_WHITE,
          },
        }),
      ]}
      {...restProps}
    >
      {children}
    </Link>
  )
}
